// Google Places autocomplete for every address field flagged with
// `data-address-autocomplete`. Uses the same options as the eligibility pages so
// an address typed in a study form behaves like one typed in an eligibility search.
const AUTOCOMPLETE_OPTIONS = {
  componentRestrictions: { country: "fr" },
  types: ["address"]
};

export function bindAddressAutocomplete(input) {
  if (!input || input.dataset.addressAutocompleteBound === "1") {
    return null;
  }

  if (!window.google || !window.google.maps || !window.google.maps.places) {
    return null;
  }

  input.dataset.addressAutocompleteBound = "1";

  return new window.google.maps.places.Autocomplete(input, AUTOCOMPLETE_OPTIONS);
}

export function initAddressAutocomplete(root = document) {
  root.querySelectorAll("[data-address-autocomplete]").forEach((input) => bindAddressAutocomplete(input));
}

// Turbolinks replaces the body on navigation, so re-run on every page load.
["DOMContentLoaded", "turbolinks:load"].forEach((event) => {
  document.addEventListener(event, () => initAddressAutocomplete());
});
